export const getDaysToExpiration = (expirationDateString) => {
  const expirationDate = Date.parse(expirationDateString);
  const today = Date.now();
  const diff = Math.abs(expirationDate - today);
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};
